<template>
    <div class="animated fadeIn equipmentList bgV2 heig-frame">
        <template class v-if="Item && Item.checklists">
            <b-row>
                <b-col md="12">
                    <div class="jobTitlePage">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h2>{{Item.job_number}}</h2>
                                <div class="d-flex align-items-center mt-15">
                                    <ul>
                                        <li class="inherit_title"><h4 class="mb-0">{{Item.service_category_abbr}}</h4></li>
                                        <li class="inherit_title"><h4 class="mb-0">Frequency {{Item.maintenance_schedule && Item.maintenance_schedule.get_sor_recurring_mode && Item.maintenance_schedule.get_sor_recurring_mode.recurring_mode ? Item.maintenance_schedule.get_sor_recurring_mode.recurring_mode : '' }}</h4></li>
                                    </ul>
                                </div>
                            </div>
                            <div>
                                <h4 class="text-right text-uppercase color-primary-highlight mb-10">{{ Item.job_status }}</h4>
                                <template v-if="(Item.job_status == 'Verified' || Item.job_status == 'Completed' || Item.job_status == 'Endorsed') &&
                                    Item.frequency && ( Item.frequency == '5Y' )">
                                    <gofix-button class="mr-3" label="Regenerate Report 5 Year" @click="regenerateReport"></gofix-button>
                                </template>
                                <template v-if="Item && (Item.job_status == 'Completed' && (Item.maintenance && Item.maintenance.sor_code.search('WSH') != -1)) && (Item.cwo_orders && Item.cwo_orders.order_status && Item.cwo_orders.order_status == 'Completed')">
                                    <gofix-button class="mr-3" label="Safety Inspection Report" @click="generateSafetyInspectionReport"></gofix-button>
                                </template>
                                <template v-if="Item.job_status == 'Verified' || Item.job_status == 'Completed'">
                                    <gofix-button class="mr-3" label="HDB Inspection Report" @click="reportHDB"></gofix-button>
                                    <b-button class="mr-3 goFixPrintButton" title="Print" v-b-tooltip.hover><i class="icon-printer icons" @click="reportJobSummary"></i></b-button>
                                </template>
                                <template v-if="
                                    (Item.job_status == 'Verified'|| Item.job_status == 'Completed'|| Item.job_status == 'Endorsed') &&
                                    Item.frequency && ( Item.frequency== '1Y' || Item.frequency == '5Y' )
                                ">
                                    <gofix-button class="mr-3" :label="Item.frequency == '1Y' ? 'Report For Annual' : 'Report For 5 Year'" @click="modal.reportFomat.open = true"></gofix-button>
                                </template>
                                <!-- <gofix-button v-if="Item.job_status == 'Completed' && Item.service_category_abbr == 'PO'" class="mr-2 dark" label="Clone Job" @click="openModalCloneJob"></gofix-button> -->
                                <gofix-button v-if="is_rescheduled" class="mr-2" label="Reschedule" @click="modal.rescheduled.open = true"></gofix-button>
                                <gofix-button v-if="Item.job_status == 'Verified' && $checkRole($accessModule.job_spe, 'endorse_job')" class="mr-2" label="Endorse" :loading="isActionEndorse" @click="endorseJob"></gofix-button>
                                <gofix-button :disabled="!$checkRole($accessModule.job_list, 'create') || loading || isEditJob || disablePreCondition" label="Save" @click="updateData"></gofix-button>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <gofix-tab :data="tabData" :variableWidth="true" >
                <template slot="gofixTab:main_info">
                    <!-- Info -->
                    <gofix-card title=" " classHeader="mb-2" classContent="position-relative pr-83">
                        <b-row class="mb-16">
                            <b-col md="5">
                                <b-row>
                                    <b-col md="6">
                                        <gofix-text-field label="Planned Date" oneline>{{ Item.planned_date ? $options.filters.formatDatebyMoment(Item.planned_date, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="6">
                                        <gofix-text-field label="Started Date" oneline>
                                            {{ Item.start_date ? $options.filters.formatDatebyMoment(Item.start_date, "YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") : "n/a" }}
                                            <b-button class="ml-2 p-0 bg-transparent border-0 goFixLocationButton" title="Geo Coordinates" v-b-tooltip.hover @click="showGeoLocation('started')">
                                                <i class="icon-location-pin color-orange font-weight-bolder"></i>
                                            </b-button>
                                        </gofix-text-field>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col md="7">
                                <b-row>
                                    <b-col md="4">
                                        <gofix-text-field label="Equipment" oneline>{{ Item.equipment && Item.equipment.tag_name ? Item.equipment.tag_name : '' }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="4"></b-col>
                                    <b-col md="4">
                                        <gofix-text-field classInner="justify-content-end" label="Status" oneline>{{ Item.job_status }}
                                        </gofix-text-field>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <span style="top: 0 !important; right: 31px !important;" @click="editBacsicInfo" class="editBox position-absolute cursor-pointer">
                                <img src="img/iconPencil.png" alt="edit bacsic info" with="18px" height="18">
                            </span>
                        </b-row>
                        <b-row class="mb-16">
                            <b-col md="5">
                                <b-row>
                                    <b-col md="6">
                                        <gofix-text-field label="Completed By" oneline>{{ Item.completed_by ? Item.completed_by.name : 'n/a' }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="6">
                                        <gofix-text-field label="Completed Date" oneline>
                                            {{ Item.completed_at ? $options.filters.formatDatebyMoment(Item.completed_at, "YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") : "n/a" }}
                                            <b-button class="ml-2 p-0 bg-transparent border-0 goFixLocationButton" title="Geo Coordinates" v-b-tooltip.hover @click="showGeoLocation('completed')">
                                                <i class="icon-location-pin color-orange font-weight-bolder"></i>
                                            </b-button>
                                        </gofix-text-field>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col md="7">
                                <b-row>
                                    <b-col md="4">
                                        <gofix-text-field label="Location" oneline>{{ Item.location ? Item.location : 'n/a' }}</gofix-text-field>
                                    </b-col>
                                     <b-col md="4">
                                        <gofix-text-field classInner="justify-content-end" label="Verified By" oneline>{{ Item.accepted_by && Item.accepted_by.name ? Item.accepted_by.name : 'n/a' }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-text-field classInner="justify-content-end" label="Verified Date" oneline>{{ Item.verified_at ? $options.filters.formatDatebyMoment(Item.verified_at, "YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") : "n/a" }}</gofix-text-field>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row class="mb-16">
                            <b-col md="5">
                                <b-row>
                                    <b-col md="6">
                                        <gofix-text-field label="Endorsed By" oneline>{{ Item.endorsed_by ? Item.endorsed_by.name : 'n/a' }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="6">
                                        <gofix-text-field label="Endorsed Date" oneline>{{ Item.endorsed_at ? $options.filters.formatDatebyMoment(Item.endorsed_at, "YYYY-MM-DD HH:mm:ss","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col md="7">
                                <gofix-text-field label="Endorsed Comment" oneline>{{ Item.endorsed_comment ? Item.endorsed_comment : 'n/a' }}</gofix-text-field>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="5">
                                <b-row>
                                    <b-col md="6">
                                        <!--Logic job_end_at = completed_at_manual -->
                                        <gofix-text-field label="Job End Date" oneline>{{ Item.completed_at_manual ? $options.filters.formatDatebyMoment(Item.completed_at_manual, "YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") : "n/a" }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="6" v-if="Item && (Item.job_status == 'Completed' && Item.maintenance && Item.maintenance.sor_code.search('WSH') != -1)">
                                        <gofix-text-field label="CWO Status" oneline>{{ Item.cwo_orders && Item.cwo_orders.order_status ? Item.cwo_orders.order_status : "" }}</gofix-text-field>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </gofix-card>
                    <!-- Content Checklist -->
                    <gofix-card :class="['position-relative mb-13 pt-16 px-24 pb-19', {'run-loading': loadingCheckListEntry }]" classHeader="mb-0 pd-0" classContent="pd-0 mb-0">
                        <b-row no-gutters>
                            <template v-for="(item, index) in tableItems">
                                <b-col md="12" class="mb-13" :key="index" v-if="item.children.length == 0">
                                    <checklist-entries :section="item.name" @updateCheckListEntries="updateCheckListEntries" @selectChecklistEntry="selectChecklistEntry" @reloadChecklist="reloadChecklist" @inputType="isTyping = true" :item="item"></checklist-entries>
                                </b-col>
                                <template v-else>
                                    <template v-for="(item1) in item.children">
                                    <b-col md="12" class="mb-13" :key="item1.id">
                                        <checklist-entries :section="item.name + ' >> ' + item1.name" @updateCheckListEntries="updateCheckListEntries" @selectChecklistEntry="selectChecklistEntry" @reloadChecklist="reloadChecklist" @inputType="isTyping = true" :item="item1"></checklist-entries>
                                    </b-col>
                                    </template>
                                </template>
                            </template>
                        </b-row>
                    </gofix-card>
                    <b-modal :no-close-on-backdrop="true" id="modal-bacsicInfo" title="Basic Info" hide-footer :centered="true" ref="modal-bacsicInfo">
                        <b-form class="pb-10">
                            <div class="content">
                                <b-row>
                                    <b-col md="3">
                                        <label>Schedule Date</label>
                                    </b-col>
                                    <b-col md="9">
                                        <div class="info-right" v-if="Item.maintenance_schedule && Item.maintenance_schedule.start_date">{{Item.maintenance_schedule.start_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}</div>
                                    </b-col>
                                </b-row>
                            </div>

                            <div class="content mb-10">
                                <b-row>
                                    <b-col md="3">
                                        <label>Equipment</label>
                                    </b-col>
                                    <b-col md="9">
                                        <div class="info-right">{{Item.equipment ? Item.equipment.tag_name : null}}</div>
                                    </b-col>
                                </b-row>
                            </div>
                            <br />

                            <template v-if="bacsicInfo.job_status === 'Endorsed'">
                                <gofix-form-dropdown label="Status" vLabel="name" :disabled="jobStatusOptions.length == 0" :filterable="false" v-model="bacsicInfo.job_status" :options="jobStatusOptions"></gofix-form-dropdown>
                                <gofix-form-input v-model="bacsicInfo.endorsed_comment" label="Description" ></gofix-form-input>
                            </template>
                            <template v-else>
                                <gofix-form-dropdown label="Status" vLabel="name" :disabled="jobStatusOptions.length == 0
                                    || (UserLogin.id == Item.completed_by_id && Item.maintenance.is_allow_fm_officer_verify_job == false  && Item.job_status == 'Completed')
                                    || (!this.$checkRole(this.$accessModule.allow_editing_job_completed, 'allow_editing_job_completed') && Item.job_status == 'Completed')
                                    || (!this.$checkRole(this.$accessModule.allow_editing_job_verified, 'allow_editing_job_verified') && Item.job_status == 'Verified')
                                    || (!this.$checkRole(this.$accessModule.job_spe, 'endorse_job') && Item.job_status == 'Verified')"
                                :filterable="false" v-model="bacsicInfo.job_status" :options="jobStatusOptions"></gofix-form-dropdown>
                                <gofix-form-dropdown label="Completed by" vLabel="name" @search="searchUsers" :filterable="false" v-model="bacsicInfo.completed_by_id" :options="users"></gofix-form-dropdown>

                                <gofix-form-dropdown label="Verified By" vLabel="name" @search="searchUsers" :filterable="false" v-model="bacsicInfo.verified_by_id" :options="users"></gofix-form-dropdown>
                                <template v-if="Item.service_category_abbr && Item.service_category_abbr.toLowerCase() == 'wsh' && Item.job_status == 'Started' && bacsicInfo.job_status == 'Completed'">
                                    <gofix-form-dropdown label="Property Manager" vLabel="name" @search="searchUsers" :filterable="false" v-model="bacsicInfo.property_manager_id" :options="users"></gofix-form-dropdown>
                                    <gofix-form-dropdown label="Contractor Supervisor" vLabel="name" @search="searchUsers" :filterable="false" v-model="bacsicInfo.contractor_supervisor_id" :options="users"></gofix-form-dropdown>
                                </template>
                                <b-row>
                                    <b-col md="6">
                                        <gofix-form-input-date :disabled="!isAllowEditStartDate" v-model="bacsicInfo.start_date" label="Start Date"></gofix-form-input-date>
                                    </b-col>
                                    <b-col md="6">
                                        <gofix-form-input-time :disabled="!isAllowEditStartDate" label="Start Time" v-model="bacsicInfo.start_date_hour"></gofix-form-input-time>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="6">
                                        <gofix-form-input-date v-model="bacsicInfo.completed_at" label="Completed Date"></gofix-form-input-date>
                                    </b-col>
                                    <b-col md="6">
                                        <gofix-form-input-time label="Completed Time" v-model="bacsicInfo.completed_at_hour"></gofix-form-input-time>
                                    </b-col>
                                </b-row>
                            </template>
                        </b-form>
                        <b-button-group class="d-block text-right">
                            <gofix-button label="APPLY" @click="checkShowPopUpSignature" :loading="isActionBI" noBorder></gofix-button>
                        </b-button-group>
                    </b-modal>
                    <b-modal :no-close-on-backdrop="true" ref="modalThumb" id="modalThumb" hide-footer>
                        <view-img :Imgs="attachments_show_modal"></view-img>
                    </b-modal>
                    <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="is_open_signature">
                        <div class="center">You don't have enough signatures to <br/>get the job done. <br/>Do you want to <strong>continue?</strong>?</div>
                        <b-button-group class="btn-group">
                            <b-button class="custom-btn" @click="is_open_signature = false">No</b-button>
                            <b-button class="custom-btn" :disabled="isActionBI" @click="updateBasicInfo"> <b-spinner v-if="isActionBI" small type="grow"></b-spinner> Yes</b-button>
                        </b-button-group>
                    </b-modal>
                </template>
                <template slot="gofixTab:service_report">
                    <work-finding></work-finding>
                    <action-taken></action-taken>
                    <signature></signature>
                </template>
                <template slot="gofixTab:activity-log">
                  <activities ref="activities" activityType="Job" :activityId="$route.params.id"></activities>
                </template>
                <template slot="gofixTab:pre-condition-checklist">
                  <PreConditionChecklist ref="PreConditionChecklist" activityType="Job" :activityId="$route.params.id" :itemProp="Item"></PreConditionChecklist>
                </template>
            </gofix-tab>
        </template>
        <b-modal :no-close-on-backdrop="true" title="Reschedule" ref="modal-rescheduled" class="modal-schedule-detail" hide-footer :centered="true" id="modal-rescheduled-job" v-model="modal.rescheduled.open">
            <b-form class="formV2">
                <b-row class="content scheduleInfo">
                    <b-col md="12">
                        <gofix-form-input-date
                            v-model="modal.rescheduled.data.start_date"
                            :required="true"
                            label="Start Date">
                        </gofix-form-input-date>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-input label="Reason" :required="true" v-model="modal.rescheduled.data.reason_rescheduled"></gofix-form-input>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right pr-4 clear-both mb-3">
                <gofix-button @click="reScheduled" label="RESCHEDULE" :loading="isActionReScheduled" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal
            id="modal-Remove"
            :title="modal.geo.title"
            :no-close-on-backdrop="true"
            dialog-class="modal-confirm-update"
            hide-footer
            :centered="true"
            v-model="modal.geo.open">
            <div class="py-3">
                <ul class="list-group">
                    <li class="list-group-item border-0 text-left">
                        <gofix-text-field label="Longitude:" classLabel="width-70" oneline>{{ location[modal.geo.type] && location[modal.geo.type].longtitude ? location[modal.geo.type].longtitude : '--' }}</gofix-text-field>
                    </li>
                    <li class="list-group-item border-0 text-left">
                        <gofix-text-field label="Latitude:" classLabel="width-70" oneline>{{ location[modal.geo.type] && location[modal.geo.type].latitude ? location[modal.geo.type].latitude : '--' }}</gofix-text-field>
                    </li>
                </ul>
            </div>
        </b-modal>
        <ModalRemarkFollowUp v-model="modal.remark.open" :item="modal.remark.checklistEntry" @reloadChecklist="reloadChecklist"/>
        <!-- <div style="width: 800px; position: fixed; opacity: 0; z-index:0;">
            <LineChart :item="Item"/>
        </div> -->
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" dialog-class="modal-confirm-update" hide-footer hide-header :centered="true" v-model="modal.reportFomat.open">
            <div class="center px-4 pt-3 pb-4">
             <h4 class="mb-2">Please select report fomat</h4>
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="reportJob('report_path')">Original Format</b-button>
            </b-button-group>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="reportJobBCA('pre092022')">BCA format</b-button>
            </b-button-group>
          <b-button-group class="btn-group">
            <b-button class="custom-btn" @click="reportJobBCA('092022')">BCA Format (September Version)</b-button>
          </b-button-group>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modal.reportFomat.open = false">Cancel</b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" ref="clone-job" hide-footer title="Clone Job" :centered="true" id="modal-custom-maint-v2" size="lg" v-model="modals.create">
            <div class="content contractTree d-flex">
                <div class="modal-left float-left boxGg boxInfo modal-left-location pt-3">
                    <div class="title text-dark"> Job Detail </div>
                    <p class="mt-3 mb-2"><strong>Planned Date:</strong> {{ Item && Item.planned_date ? Item.planned_date : null | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}</p>
                    <p class="mb-2"><strong>Completed By:</strong> {{ Item && Item.completed_by ? Item.completed_by.name : 'n/a' }}</p>
                    <p class="mb-2"><strong>Endorsed By:</strong> {{ Item && Item.endorsed_by ? Item.endorsed_by.name : 'n/a' }}</p>
                    <p class="mb-2"><strong>Started Date:</strong> {{ Item && Item.start_date ? Item.start_date : null | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}</p>
                    <p class="mb-2"><strong>Completed Date:</strong> {{ Item && Item.completed_at ? Item.completed_at : null | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}</p>
                    <p class="mb-2"><strong>Endorsed Date:</strong> {{ Item && Item.endorsed_at ? Item.endorsed_at : null | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}</p>
                    <p class="mb-2"><strong>Equipment:</strong> {{ Item && Item.equipment && Item.equipment.tag_name ? Item.equipment.tag_name : '' }}</p>
                    <p class="mb-2"><strong>Location:</strong> Block A >> Level 4 >> 401</p>
                    <p class="mb-2"><strong>Endorsed Comment:</strong> {{ Item && Item.endorsed_comment ? Item.endorsed_comment : 'n/a' }}</p>
                    <p class="mb-2"><strong>Job End Date:</strong> {{ Item && Item.completed_at_manual ? Item.completed_at_manual : null | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}</p>  
                </div>
                <div class="modal-tree-location float-left boxGg pt-3">
                    <div class="title text-dark"> Property </div>
                    <div class="tree-view-properties mt-3">
                        <gofix-form-properties 
                            label="Location" 
                            :property-id="rootIds ? rootIds.property_root_id : null" 
                            valueFormat="object"  
                            v-model="properties" 
                            :show-icon-required="true" 
                            :multiple="true"
                            :alwaysOpen="true"
                            :flat="true"
                            :defaultExpandLevel="1"
                            :maxHeight="350"
                            :limit="0"
                            :limitText="count => `${count} items selected.`"
                            :sortValueBy="'INDEX'"
                            :propertyIdsDisable="rootIds.property_ids_disable"
                            class="gofixInputNoMinWidth text-normal">
                        </gofix-form-properties>
                    </div>
                </div>
                <div class="modal-right-location pt-3 float-left boxGg">
                    <div class="title text-dark"> Selected Locations </div>
                    <div class="bottomDiv selected-location">
                        <ul class="list-unstyled">
                            <li v-for="item in properties" :key="item.id" >
                                <span v-bind:title="item.root_path">{{item.name}}</span>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
            <b-button-group class="d-block text-right pr-4 clear-both mb-3">
                <gofix-button label="CANCEL" @click="modals.create = false" noBorder dark></gofix-button>
                <gofix-button label="SAVE" @click="saveCloneJob" :loading="isActionCloneJob" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
// const LineChart = () => import("./chart.vue")
const WorkFinding = () => import("./CheckList_work_finding.vue")
const ActionTaken = () => import("./CheckList_action_taken.vue")
const Signature = () => import("./CheckList_signature.vue")
const Priority = () => import('./modal_priority.vue')
const Activities = () => import("../global/Activities")
const ChecklistEntries = () => import("./CheckListEntries")
const ModalRemarkFollowUp = () => import("./modal_remark_follow_up")
const PreConditionChecklist = () => import("./pre-condition-checklist")
import {
    mapGetters
} from "vuex";
import {
    filters
} from "@/_filterVar.js";
import moment from 'moment';
export default {
    name: "check-list",
    components: {
        // LineChart,
        WorkFinding,
        ActionTaken,
        Signature,
        Priority,
        Activities,
        ChecklistEntries,
        ModalRemarkFollowUp,
        PreConditionChecklist
    },
    data() {
        let filter = JSON.parse(JSON.stringify(filters["sor_master"]));
        return {
            tabData: [{
                    key: "main_info",
                    title: "Main Info",
                    active: true
                },
                {
                    key: "service_report",
                    title: "Service Report",
                    active: false
                },
                {
                  key: "activity-log",
                  title: "Activity Log",
                  active: false
                },
            ],
            fields: [
                {
                    key: 'sequence',
                    label: 'Number',
                    thStyle: 'width: 132px',
                    thClass: 'pl-25',
                    tdClass: 'pl-25',
                },
                {
                    key: 'name',
                    label: 'Service Description',
                    thStyle: 'width: 240px'
                },
                {
                    key: 'input',
                    label: 'Value Type',
                    thStyle: 'width: 150px'
                },
                {
                    key: 'value',
                    label: 'Value',
                    thStyle: 'width: 150px'
                },
                {
                    key: 'status',
                    label: 'Status',
                    thStyle: 'width: 100px'
                },
                {
                    key: 'remark_id',
                    label: 'Remarks',
                    thStyle: 'width: 175px',
                },
                {
                    key: 'follow_up',
                    label: 'Follow Up',
                    thStyle: 'width: 150px',
                    thClass: 'text-center',
                    tdClass: 'text-center'
                }
            ],
            tableItems: [],
            checkListGroupTemp:[],
            tableConfig: {
                name: "preventive-maintenance-job-and-checklist",
                controls: {
                    create: false,
                    delete: false,
                    tablePagination: false,
                    tableFilter: false,
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
            },
            isActionBI: false,
            isActionReScheduled:false,
            users: [],
            bacsicInfo: {
                completed_by_id  : "",
                verified_by_id   : "",
                start_date       : null,
                start_date_hour  : "",
                completed_at     : null,
                completed_at_hour: "",
                job_status       : "",
                endorsed_comment : "",
                property_manager_id: null,
                contractor_supervisor_id: null
            },
            attachments_show_modal: [],
            is_open_signature: false,
            item_checklist: null,
            loading: false,
            modal: {
                 rescheduled:{
                    open:false,
                    loading: false,
                    data:{
                        ids:[],
                        start_date:null,
                        reason_rescheduled:null
                    },
                },
                geo: {
                    open: false,
                    title: "",
                    type: "started"
                },
                remark: {
                    open: false,
                    checklistEntry: null
                },
              reportFomat:{
                open:false,
                loading: false
              }
            },
            timer_summary: null,
            timer_hdb: null,
            is_rescheduled:false,
            location: {
                started:   { longtitude: null, latitude: null, user: null },
                completed: { longtitude: null, latitude: null, user: null }
            },
            checkListEntryUpdate:[],
            loadingCheckListEntry:false,
            timer_save: null,
            isModalShow: false,
            isTyping: false,
            isSave: false,
            isActionEndorse: false,
            listItemEquipment: [],
            properties: null,
            isActionCloneJob: false,
            modals:{
                create:false,
                delete:false,
            },
            rootIds:{
                contract_id : null,
                property_root_id: null,
                property_ids_disable: []
            },
            loadings:{
                equipment: false,
            },
            disablePreCondition: true,
        };
    },
    computed: {
        ...mapGetters({
            UserLogin: "AuthController/user",
            Item: "JobController/Item",
            Loadings: "JobController/Loadings",
            clientContractID: 'ContractController/ClientContractID',
        }),
        jobStatusOptions() {
            switch (this.Item.job_status) {
                case "Due":
                    return ["Started", "Cancelled"];
                    break;
                case "Started":
                    return ["Completed", "Cancelled"];
                    break;
                case "Completed":
                    let status = ["Cancelled"];
                    if(this.$checkRole(this.$accessModule.allow_to_verify_job, 'allow_to_verify_job')) {
                        status = ["Verified", "Cancelled"];
                    }
                    return status;
                    break;
                case "Expired":
                    if(this.Item.maintenance && this.Item.maintenance.is_allow_fm_officer_to_do_expired_jobs) {
                        return ["Started"];
                        break;
                    }
                    return [];
                    break;
                /*case "Verified":
                    return ["Endorsed"];
                    break;*/
                default:
                    return [];
            }
        },
        isEditJob() {
            if(!this.Item) return true;
            if(this.Item.maintenance && this.Item.maintenance.editing_of_checklist && !this.Item.maintenance.editing_of_checklist.includes(this.Item.job_status)) return true;
            if(['Completed'].includes(this.Item.job_status) && !this.$checkRole(this.$accessModule.allow_editing_job_completed, 'allow_editing_job_completed')) return true;
            if(['Verified'].includes(this.Item.job_status) && !this.$checkRole(this.$accessModule.allow_editing_job_verified, 'allow_editing_job_verified')) return true;
            // if(this.Item.job_status === 'Completed' || this.Item.job_status === 'Endorsed' || this.Item.job_status == 'Expired' || this.Item.job_status == 'Cancelled') return true;
            // if(this.Item.job_status === 'Verified' && (this.Item.frequency && (this.Item.frequency != '1Y' && this.Item.frequency != '5Y'))) return true;
            return false;
        },
        isAllowEditStartDate() {
            if(!this.Item || !this.Item.editing_of_job_data_action || !this.Item.editing_of_job_data_action.is_allow_edit_start_date) return false;
            return true;
        },
        isAllowReschedule() {
            if(!this.Item || !this.Item.editing_of_job_data_action || !this.Item.editing_of_job_data_action.is_allow_reschedule) return false;
            return true;
        } 
    },
    watch: {
        imgFollowUp(val, old) {
            if (val) {
                val.forEach((file) => {
                    if (
                        file.type != "image/jpeg" &&
                        file.type != "image/png" &&
                        file.type != "image/gif"
                    ) {
                        this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                        return;
                    }
                    file.moment = moment().valueOf();
                    let data = {
                        moment: moment().valueOf(),
                        url: {
                            original: URL.createObjectURL(file),
                            medium: URL.createObjectURL(file),
                            thumb: URL.createObjectURL(file),
                        },
                    };
                    this.imgFollowUpAction.photos.push(file);
                    this.checkListItem.follow_up.attachments.push(data);
                });
            }
        },
        imgActionTaken(val) {
            if (val) {
                val.forEach((file, index) => {
                    if (
                        file.type != "image/jpeg" &&
                        file.type != "image/png" &&
                        file.type != "image/gif"
                    ) {
                        this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                        return;
                    }
                    file.moment = moment().valueOf() + index;
                    let data = {
                        moment: moment().valueOf() + index,
                        url: {
                            original: URL.createObjectURL(file),
                            medium: URL.createObjectURL(file),
                            thumb: URL.createObjectURL(file),
                        },
                    };
                    this.imgActionTakenAction.photos.push(file);
                    this.checkListItem.action_taken_photos.push(data);
                });
            }
        },
        Item: function(val, old) {
            if(val){
                this.is_rescheduled = false
                let status = val.job_status;
                if(val.maintenance.allow_job_rescheduled.includes(status) && val.editing_of_job_data_action && val.editing_of_job_data_action.is_allow_reschedule){
                    this.is_rescheduled = true
                }

                // callback Contract selector
                if(val.client_contract_id && (!this.clientContractID || !this.clientContractID.id || (this.clientContractID && this.clientContractID.id && this.clientContractID.id != val.client_contract_id))) {
                    this.$store.dispatch( 'ContractController/getClientContractID', val.client_contract_id).then(response => {
                        localStorage.setItem("ClientContractID", JSON.stringify(response.data.data));
                    })
                }

                /* check status show tab: pre-condition-checklist */
                if ( ['1Y', '5Y'].includes(this.Item.frequency) == true && this.Item.maintenance.is_pre_condition_checklist_mandatory_complete == true ) {
                    let arrFind = this.tabData.filter(item => item.key == 'pre-condition-checklist');
                    if(!arrFind.length) {
                        this.tabData.push({
                            key: "pre-condition-checklist",
                            title: "Pre-Condition Checklist",
                            active: false
                        });
                    }
                }

                /* check enable save button [pre-condition-checklist] */
                if ( ['1Y', '5Y'].includes(this.Item.frequency) == true && this.Item.maintenance.is_pre_condition_checklist_mandatory_complete == true && this.Item.is_pre_condition == false && ['Due', 'Planned'].includes(this.Item.job_status) == true ) {
                    //
                } else {
                    this.disablePreCondition = false;
                }
            }
        },
        isTyping: function(val) {
            if(val === false && this.isSave === true) {
                this.updateData();
            }
        }
    },
    mounted() {
        const _this = this;
        this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            if(modalId == 'msgConfirm') _this.isModalShow = true;
        })
        this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
            if(modalId == 'msgConfirm') _this.isModalShow = false;
        })
    },
    created() {
        if (
            !this.$route.params.hasOwnProperty("id") ||
            isNaN(this.$route.params.id)
        ) {
            return this.$router.push({
                name: "job-list"
            });
        }

        this.getItemJob();
        this.getCheckListGroupData();
        this.getUserLocationJob();
    },
    methods: {
        async updateCheckListEntries(val){
            let params = val;
            let request = {
                id: params.val.id,
                value: params.val.input.value,
                status: params.val.status,
            }
            if(params.val.hasOwnProperty('output')) request.output = params.val.output;
            if(params.val.hasOwnProperty('is_output_highlighted')) request.is_output_highlighted = params.val.is_output_highlighted;
            if(!params.from_status){
                if(params.val.input.value){ request.status = params.val.status = 'Filled'; }
                else{ request.status = params.val.status = 'Unfilled';}
            }

            let checkListEntryData = [request];
            if(this.checkListEntryUpdate.length > 0){
                checkListEntryData = Object.assign([], this.checkListEntryUpdate);
            }
            let flag = false;
            if(checkListEntryData.length > 0){
                for (let i = 0; i < checkListEntryData.length; i++) {
                    if (request && request.id == checkListEntryData[i].id) {
                        this.checkListEntryUpdate[i] = request;
                        flag = true;
                        break;
                    }
                }
                if(!flag){
                    this.checkListEntryUpdate.push(request);
                }
            }
            this.isTyping = false;
        },
        async getCheckListGroupData(){
            this.loadingCheckListEntry = true;
            await this.$store
                .dispatch("CheckListController/getCheckListGroupData", this.$route.params.id)
                .then((result) => {
                    this.tableItems = result.data.data.items;
                    this.loadingCheckListEntry = false;
                })
                .catch((err) => {
                    this.loadingCheckListEntry = false;
            });
        },
        async getItemJob(callback) {
            await this.$store.dispatch("JobController/getItem", this.$route.params.id)
            .then((response) => {})
            .catch((err) => {
                this.$alertNotification("Can not load job list", "danger");
            });
        },
        modalThumb(attachments) {
            this.attachments_show_modal = [];
            if (attachments) {
                this.attachments_show_modal = attachments;
            }
            this.$refs["modalThumb"].show();
        },
        async reScheduled(){
            if(!this.modal.rescheduled.data.start_date) {
                return this.$alertNotification("Start Date is required", "danger");
            }
            if(!this.modal.rescheduled.data.reason_rescheduled) {
                return this.$alertNotification("Reason is required", "danger");
            }
            if (this.isActionReScheduled) return;
            this.isActionReScheduled = true;
            let start_date = moment(new Date(this.modal.rescheduled.data.start_date)).format(
                "YYYY-MM-DD"
            );
            let data = {
                ids: [this.Item.id],
                start_date: start_date,
                reason_rescheduled: this.modal.rescheduled.data.reason_rescheduled
            };
            await this.$store
                .dispatch("JobController/reScheduledRunsheet", data)
                .then((result) => {
                    this.isActionReScheduled = false;
                    this.is_rescheduled = false;
                    this.$alertNotification('Reschedule success!');
                    this.$refs["modal-rescheduled"].hide();
                })
                .catch((err) => {
                    this.$refs["modal-rescheduled"].hide();
                    this.isActionReScheduled = false;
                    if(err.response.data.error.message.error){
                        return this.$alertNotification(err.response.data.error.message.error, "danger");
                    }
            });
            await this.$store.dispatch("JobController/getItem", this.Item.id)
            .then((result) => {})
            .catch((err) => {});
        },
        updateData() {
            if (this.timer_save) {
                clearTimeout(this.timer_save);
                this.timer_save = null;
            }
            this.timer_save = setTimeout(() => {
                if(this.isTyping) {
                    this.isSave = true;
                    return;
                }
                if(this.isModalShow) return;
                this.isSave = false;

                if (!this.$checkRole(this.$accessModule.job_list, "create")) {
                    return;
                }
                var checkValidate = this.checkListEntryUpdate.filter(function(item) {
                    return (item.status === 'Filled' && !item.value);
                });
                if(checkValidate.length > 0){
                    return this.$alertNotification("Please enter checklist entries value when the status Filled", "danger");
                }
                this.loading = true;
                let request = {
                    array_data: JSON.stringify(this.checkListEntryUpdate),
                    job_id: this.Item.id
                };
                this.$store
                    .dispatch("CheckListController/updateCheckListJob", request)
                    .then(async (data) => {
                        await this.getItemJob();
                        this.loading = await false;
                        this.checkListEntryUpdate = [];
                        this.$alertNotification(this.$notificationV2("editing", "checklist"));
                    })
                    .catch((err) => {
                        this.$alertNotification("Can not update checklist!", "danger");
                    });
            }, 100);
        },
        editBacsicInfo() {
            if (this.users.length == 0) {
                this.loadUser(100, null);
            }
            this.bacsicInfo.job_status       = this.Item.job_status;
            this.bacsicInfo.endorsed_comment = this.Item.endorsed_comment;
            this.bacsicInfo.completed_by_id  = this.Item.completed_by;
            this.bacsicInfo.verified_by_id   = this.Item.accepted_by;
            this.bacsicInfo.start_date = this.Item.start_date ?
                new Date(this.Item.start_date) :
                null;
            this.bacsicInfo.start_date_hour = this.Item.start_date ?
                moment(new Date(this.Item.start_date)).format("HH:mm") :
                null;
            this.bacsicInfo.completed_at = this.Item.completed_at ?
                new Date(this.Item.completed_at) :
                null;
            this.bacsicInfo.completed_at_hour = this.Item.completed_at ?
                moment(new Date(this.Item.completed_at)).format("HH:mm") :
                null;

            this.$refs["modal-bacsicInfo"].show();
        },
        loadUser(limit_item, filters) {
            this.$store
                .dispatch("v2UserController/searchListUser", {
                    limit: limit_item,
                    page: 1,
                    filters: filters,
                })
                .then((response) => {
                    this.users = response.data;
                })
                .catch((err) => {});
        },
        searchUsers(search, loading) {
            loading(true);
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.loadUser(100, {
                    name: search
                });
                loading(false);
            }, 500);
        },
        checkShowPopUpSignature() {
            if(this.bacsicInfo.job_status == 'Completed'
                && this.Item.maintenance.number_of_required_signature > 0
                && this.Item.signatures.length < this.Item.maintenance.number_of_required_signature
            ) {
                this.is_open_signature = true;
            } else {
                this.updateBasicInfo();
            }
        },
        updateBasicInfo() {
            if (this.isActionBI) return;
            this.isActionBI = true;

            let start_date        = "";
            let completed_at      = "";
            let start_date_hour   = "";
            let completed_at_hour = "";
            let completed_by_id   = "";
            let verified_by_id    = "";
            let property_manager_id    = "";
            let contractor_supervisor_id    = "";

            if (this.bacsicInfo.completed_by_id != null) {
                completed_by_id = this.bacsicInfo.completed_by_id.id;
            }

            if (this.bacsicInfo.verified_by_id != null) {
                verified_by_id = this.bacsicInfo.verified_by_id.id;
            }

            if (this.bacsicInfo.start_date != null) {
                start_date = moment(new Date(this.bacsicInfo.start_date)).format(
                    "YYYY-MM-DD"
                );
            }

            if (this.bacsicInfo.completed_at != null) {
                completed_at = moment(new Date(this.bacsicInfo.completed_at)).format(
                    "YYYY-MM-DD"
                );
            }

            if (this.bacsicInfo.start_date_hour != null) {
                start_date_hour = this.bacsicInfo.start_date_hour + ":00";
            }

            if (this.bacsicInfo.completed_at_hour != null) {
                completed_at_hour = this.bacsicInfo.completed_at_hour + ":00";
            }

            if (this.bacsicInfo.property_manager_id != null) {
                property_manager_id = this.bacsicInfo.property_manager_id.id;
            }

            if (this.bacsicInfo.contractor_supervisor_id != null) {
                contractor_supervisor_id = this.bacsicInfo.contractor_supervisor_id.id;
            }

            this.$store
                .dispatch("JobController/updateRunsheet", {
                    data: {
                        start_date       : start_date,
                        start_date_hour  : start_date_hour,
                        completed_at     : completed_at,
                        completed_at_hour: completed_at_hour,
                        completed_by_id  : completed_by_id,
                        verified_by_id   : verified_by_id,
                        job_status       : this.bacsicInfo.job_status,
                        endorsed_comment : this.bacsicInfo.endorsed_comment,
                        property_manager_id     : property_manager_id,
                        contractor_supervisor_id: contractor_supervisor_id,
                    },
                    id: this.Item.id,
                })
                .then((result) => {
                    this.isActionBI = false;
                    this.$alertNotification(this.$notificationV2("editing", "job_list"));
                    this.is_open_signature = false;
                    this.$refs["modal-bacsicInfo"].hide();
                })
                .catch((err) => {
                    this.$refs["modal-bacsicInfo"].hide();
                    this.isActionBI = false;
                    if(err.response.data.error.message.error){
                        return this.$alertNotification(err.response.data.error.message.error, "danger");
                    }
                });
        },
        endorseJob () {
            if (this.isActionEndorse) return;
            this.isActionEndorse = true;
            this.$store
                .dispatch("JobController/updateRunsheet", {
                    data: {
                        job_status: "Endorsed"
                    },
                    id: this.Item.id,
                })
                .then((result) => {
                    this.isActionEndorse = false;
                    this.$alertNotification(this.$notificationV2("editing", "job_list"));
                    this.is_open_signature = false;
                    this.$refs["modal-bacsicInfo"].hide();
                })
                .catch((err) => {
                    this.$refs["modal-bacsicInfo"].hide();
                    this.isActionEndorse = false;
                    if(err.response.data.error.message.error){
                        return this.$alertNotification(err.response.data.error.message.error, "danger");
                    }
                });
        },
        reportJob(formatType = 'report_path') {
            this.modal.reportFomat.open = false
            if(this.loading) return;
            this.loading = true;
            let name_report = '';
            if(this.Item.frequency) {
                if(this.Item.frequency == '1Y') {
                    name_report = 'Report For Annual ';
                }

                if(this.Item.frequency == '5Y') {
                    name_report = 'Report For 5 Year ';
                }

                if(this.Item.equipment && this.Item.equipment.tag_name) {
                    name_report += `${this.Item.equipment.tag_name} `;
                }

                name_report += `${moment().format('DD-MMM-YYYY')}.pdf`;
            }

            let nameFile = name_report ? name_report : 'report.pdf';
            // let canvas = document.getElementById('line-chart').toDataURL('image/png', 1.0);
            this.$store.dispatch("JobController/reportJob", {
                id: [this.Item.id],
                mutil_file: false,
               format_type: formatType,
            })
            .then(response => {
                this.loading = false;
                if(response.data.size === 0) {
                    this.$alertNotification("Blank report", "warning");
                    return;
                }
                if(response.headers["content-disposition"]) {
                    let arrTemp = response.headers["content-disposition"].split("filename=");
                    if(arrTemp[1]) {
                        nameFile = arrTemp[1].replaceAll('"', "");
                    }
                }
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', nameFile);
                document.body.appendChild(link);
                link.click();
            }).catch(err => {
                this.loading = false;
            });
        },
        reportJobBCA(version = '092022'){
          this.modal.reportFomat.open = false
          if(this.loading) return;
          this.loading = true;
          let name_report = '';
          if(this.Item.frequency) {
            if(this.Item.frequency == '1Y') {
              name_report = 'Report For Annual ';
            }

            if(this.Item.frequency == '5Y') {
              name_report = 'Report For 5 Year ';
            }

            if(this.Item.equipment && this.Item.equipment.tag_name) {
              name_report += `${this.Item.equipment.tag_name} `;
            }

            name_report += `${moment().format('DD-MMM-YYYY')}.pdf`;
          }

          let nameFile = name_report ? name_report : 'report.pdf';
        //   let canvas = document.getElementById('line-chart').toDataURL('image/png', 1.0);
          this.$store.dispatch("JobController/reportJobBCA", {
            ids: [this.Item.id],
            version: version,
          })
              .then(response => {
                this.loading = false;
                if(response.data.size === 0) {
                  this.$alertNotification("Blank report", "warning");
                  return;
                }
                if(response.headers["content-disposition"]) {
                  let arrTemp = response.headers["content-disposition"].split("filename=");
                  if(arrTemp[1]) {
                    nameFile = arrTemp[1].replaceAll('"', "");
                  }
                }
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', nameFile);
                document.body.appendChild(link);
                link.click();
              }).catch(err => {
            this.loading = false;
          });
        },
        reportJobSummary() {
            if (this.timer_summary) {
                clearTimeout(this.timer_summary);
                this.timer_summary = null;
            }
            this.timer_summary = setTimeout(() => {
                let nameFile = 'VerifiedJobSummaryReport.pdf';
                this.$store.dispatch("JobController/reportJobSummary", {
                    id: this.Item.id,
                    type: ''
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nameFile);
                    document.body.appendChild(link);
                    link.click();
                });
            }, 300);
        },
        checkEditChecklist() {
            // if(this.Item.job_status == 'Expired' || this.Item.job_status == 'Verified' || this.Item.job_status == 'Cancelled' ||this.Item.job_status == 'Endorsed')
            if(this.Item.maintenance && this.Item.maintenance.editing_of_checklist && !this.Item.maintenance.editing_of_checklist.includes(this.Item.job_status))
                return true
            if(this.isfollowUp)
                return true
            // if(this.Item.job_status == 'Completed' && !(this.Item.maintenance && this.Item.maintenance.is_allow_editing_of_follow_up_after_job_completion))
            //     return true
            return false
        },
        getUserLocation(type) {
            return new Promise((resolve, reject) => {
                this.$store.dispatch("JobController/getUserLocationJob", {
                    limit: 1,
                    showRelationship: '1',
                    filter: {
                        type: "job",
                        type_id: this.$route.params.id,
                        action: type
                    }
                })
                .then(response => {
                    resolve(response.items)
                });
            });
        },
        getUserLocationJob() {
            Promise.all([
                this.getUserLocation("Started"),
                this.getUserLocation("Completed")
            ]).then((values) => {
                if(values && values.length === 2) {
                    if(values[0] && values[0][0] && values[0][0].longitude && values[0][0].latitude) {
                        this.location.started.longtitude = values[0][0].longitude;
                        this.location.started.latitude   = values[0][0].latitude;
                        this.location.started.user       = values[0][0].user || null;
                    }

                    if(values[1] && values[1][0] && values[1][0].longitude && values[1][0].latitude) {
                        this.location.completed.longtitude = values[1][0].longitude;
                        this.location.completed.latitude   = values[1][0].latitude;
                        this.location.completed.user       = values[1][0].user || null;
                    }
                }
            });
        },
        showGeoLocation(type) {
            if(type == "started") {
                this.modal.geo.title = "Started by: ";
                if(this.location.started.user  && this.location.started.user.name)  this.modal.geo.title += this.location.started.user.name;
                else this.modal.geo.title += "--";
            }

            if(type == "completed") {
                this.modal.geo.title = "Completed by: ";
                if(this.location.completed.user  && this.location.completed.user.name)  this.modal.geo.title += this.location.completed.user.name;
                else this.modal.geo.title += "--";
            }

            this.modal.geo.type = type;
            this.modal.geo.open = true;
        },
        selectChecklistEntry(entry) {
            this.modal.remark.checklistEntry = entry;
            this.modal.remark.open = true;
        },
        reloadChecklist() {
            this.getCheckListGroupData();
        },
        openModalCloneJob() {
            this.modals.create = true

            this.rootIds.contract_id = this.clientContractID ? this.clientContractID.id : null
            this.rootIds.property_root_id = this.clientContractID ? this.clientContractID.property_root_id : null
            this.rootIds.property_ids_disable = [this.Item.location_id]

            if (this.rootIds.contract_id && this.rootIds.property_root_id) {
                this.loadEquipmentList()
            }
        },
        async loadEquipmentList(){
            this.loadings.equipment = true;
            
            let location = await global.axios(`api/contracts/${this.rootIds.contract_id}/properties/${this.rootIds.property_root_id}`, {
                method: "GET",
                params: {
                    is_active: true
                },
                headers: {
                    Accept: "application/json",
                }
            });

            location.data.data.data = {
                id: location.data.data.id,
            }

            location.data.data.state = {
                selected: true
            };

            if(this.$refs.tree){
                this.$refs.tree.setModel(location.data.data);
            }

            this.loadings.equipment = false;
        },
        async saveCloneJob() {
            this.isActionCloneJob = true
            let location_ids = [];

            if(this.properties != null && this.properties.length > 0){
                for(let i = 0; i < this.properties.length;i++){
                    location_ids.push(
                        this.properties[i].id
                    );
                }
            }

            if(location_ids.length <= 0){
                this.isActionCloneJob = false
                return this.$alertNotification('Please select at least 1 property!', "danger")
            }

            if (this.timer_save) {
                clearTimeout(this.timer_save);
                this.timer_save = null;
            }
            this.timer_save = setTimeout(() => {

                let request = {
                    location_ids: location_ids,
                    job_id: this.Item.id
                };

                this.$store
                .dispatch("CheckListController/cloneJob", request)
                .then(async (data) => {
                    await this.$alertNotification("Successfully clone job", "success");
                    this.isActionCloneJob = false
                    await this.$router.push('/v2/job-list/completed');
                })
                .catch((err) => {
                    if (err.response.data.error && err.response.data.error.message) {
                        this.$alertNotification(err.response.data.error.message, "danger")
                    }
                    this.isActionCloneJob = false
                });
            }, 100);
        },
        reportHDB() {
            let nameFile = 'HDBInspectionReport.pdf';
            if(this.Item && this.Item.property) {
                nameFile = ''
                if(!this.Item.property.get_address || !this.Item.property.get_address.street_no || !this.Item.property.get_address.unit_no || !this.Item.property.get_address.street_name) {
                    let arrTmp = this.Item.property.name.split(", ");
                    if(arrTmp[0]) nameFile += arrTmp[0]
                    if(arrTmp[2]) nameFile += ` ${arrTmp[2]}`
                    if(arrTmp[1]) nameFile += ` ${arrTmp[1]}`
                } else {
                    if(this.Item.property.get_address.street_no) nameFile += ` ${this.Item.property.get_address.street_no}`
                    if(this.Item.property.get_address.unit_no) nameFile += ` ${this.Item.property.get_address.unit_no}`
                    if(this.Item.property.get_address.street_name) nameFile += ` ${this.Item.property.get_address.street_name}`
                }
                nameFile = `${nameFile.trim()}.pdf`
            }

            if (this.timer_hdb) {
                clearTimeout(this.timer_hdb);
                this.timer_hdb = null;
            }
            this.timer_hdb = setTimeout(() => {
                this.$store.dispatch("JobController/reportJobSummary", {
                    id: this.Item.id,
                    type: 'HDB'
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nameFile);
                    document.body.appendChild(link);
                    link.click();
                });
            }, 300);
        },
        async regenerateReport() {
            await this.$store.dispatch("JobController/regenerateReport", this.$route.params.id)
            .then((response) => {console.log(1);this.$alertNotification("Successfully regenerate job", "success");})
            .catch((err) => {
                this.$alertNotification("Can not regenerate job", "danger");
            });
        },
        generateSafetyInspectionReport() {
            const namePDF = `Safety-Inspection-Report_${this.Item.job_number}.pdf`
            this.$store.dispatch(`JobController/generateSafetyInspectionReport`, this.$route.params.id)
            .then( response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', namePDF);
                document.body.appendChild(link);
                link.click();
            })
            .catch(error => {});
        },
    }, 
};
</script>
